<template>
  <div style="background: #f6f6f8">
    <HomePageTopVue ref="head"></HomePageTopVue>
    <div class="LogisticsCon">
      <!-- logo图标与文字 -->
      <div class="logoImg">
        <div class="base-w">
          <div class="logoInfoTxtBox">
            <!-- Rakumart专业的国际运输服务及物流解决方案 -->
            <h1 class="sr-only">
              {{ $fanyi("Rakumart专业的国际运输服务及物流解决方案") }}
            </h1>
            <!-- 我们为您全权管理 -->
            <div class="caption-kicker">{{ $fanyi("我们为您全权管理") }}</div>
            <h2>{{ $fanyi("通过Rakumart完成物流与运输") }}</h2>
            <h3>
              {{
                $fanyi(
                  "Rakumart为您管理并完成从中国到目的地的整个物流和进口过程。利用Rakumart为您提供的所有资源，彻底改变从中国采购和进口的方式，为您的业务节省时间与成本。",
                )
              }}
            </h3>
          </div>
        </div>
      </div>

      <!-- 我们的优势 -->
      <div class="moudlebackGround">
        <div class="ourAdvantages pageMoudle">
          <div class="AdvantagesTitle">
            <span>{{ $fanyi("我们的优势") }}</span>
            <div class="xian"></div>
          </div>
          <div class="AdvantagesTagGroup">
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG55.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("门到门运输") }}</div>
                <div class="tagRightConTBody">
                  {{
                    $fanyi(
                      "Rakumart为您进口商品，并全程管理运输和手续直至交付。",
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG57.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("成本优化") }}</div>
                <div class="tagRightConTBody">
                  {{
                    $fanyi(
                      "我们将来自不同供应商的货物进行整合，并统一国际运输。",
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG52.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("在中国的仓储") }}</div>
                <div class="tagRightConTBody">
                  {{
                    $fanyi("我们在中国拥有自己的仓库，用于管理所有货物的物流。")
                  }}
                </div>
              </div>
            </div>
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG54.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("质量控制") }}</div>
                <div class="tagRightConTBody">
                  {{ $fanyi("我们负责在接收到货物后进行相关的质量检查。") }}
                </div>
              </div>
            </div>
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG58.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("个性化服务") }}</div>
                <div class="tagRightConTBody">
                  {{
                    $fanyi(
                      "我们可以根据客户的需求定制服务，完全满足他们的特定要求。",
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="AdvantagesTag">
              <img
                class="tagLeftIcon"
                src="../../assets/newImg/footlist/yunshu/WechatIMG53.png"
                alt=""
              />
              <div class="tagRightCon">
                <div class="tagRightConTitle">{{ $fanyi("客户服务") }}</div>
                <div class="tagRightConTBody">
                  {{
                    $fanyi(
                      "在整个流程中的每一步都有专门的代理人员，从中国开始，并使用意大利语。",
                    )
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 物流过程 -->
      <div class="moudlebackGround">
        <div class="logisticsProcess pageMoudle">
          <div class="AdvantagesTitle">
            <span>{{ $fanyi("物流过程") }}</span>
            <div class="xian"></div>
          </div>
          <div class="logisticsProcessOPtBox">
            <img
              class="logisticsProcessOptImg"
              src="../../assets/foot-img/logistica/linea-temporal-rakumart-logistica.svg"
              alt=""
            />
            <div class="logisticsProcessOPtArr">
              <div class="logisticsProcessOPt">{{ $fanyi("工厂") }}</div>
              <div class="logisticsProcessOPt">{{ $fanyi("运输") }}</div>
              <div class="logisticsProcessOPt">{{ $fanyi("中国仓库") }}</div>
              <div class="logisticsProcessOPt">{{ $fanyi("中国海关") }}</div>
              <div class="logisticsProcessOPt">
                {{ $fanyi("国际运输阶段") }}
              </div>
              <div class="logisticsProcessOPt">{{ $fanyi("意大利海关") }}</div>
              <div class="logisticsProcessOPt">{{ $fanyi("意大利运输") }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="moudlebackGround">
        <!-- 我们将全程陪伴 -->
        <div class="companyLabor pageMoudle">
          <img
            class="LaborBackImg"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175515493852.svg"
            alt=""
          />
          <div class="LaborFontBox">
            <div class="LaborLinkFont">{{ $fanyi("完整的工厂物流服务") }}</div>
            <div class="LaborFontTitle">
              {{
                $fanyi(
                  "我们将在整个过程中全程陪伴您，从采购一直到交付到您手中。",
                )
              }}
            </div>
            <div class="LaborFontCon">
              {{
                $fanyi(
                  "Rakumart提供完整的物流服务管理，从供应商的工厂直到您的收货地址。",
                )
              }}
            </div>
            <div class="LaborFontCon">
              {{
                $fanyi(
                  "这让我们的客户可以随时了解他们的货物在进口流程中的具体环节。",
                )
              }}
            </div>
            <div class="LaborFontCon">
              {{
                $fanyi(
                  "我们在中国拥有超过70,000平方米的仓库，用于接收、处理和存储货物，直到发运到意大利。",
                )
              }}
            </div>
          </div>
        </div>
      </div>
      <!-- 运输方式表格 -->
      <div class="moudlebackGround">
        <div class="modeOfTransportationTable pageMoudle">
          <div class="modeOfTransportation">
            <div class="tul ttt">
              <div class="inBox">
                <div class="tli ttt titleBox">{{ $fanyi("运输方式") }}</div>
                <div class="tli ttt conBox">{{ $fanyi("最小体积") }}</div>
                <div class="tli ttt conBox">{{ $fanyi("最大体积") }}</div>
                <div class="tli ttt conBox">{{ $fanyi("运输时间*") }}</div>
              </div>
            </div>
            <div class="tul tbo">
              <div class="inBox">
                <div class="tli tbo titleBox">{{ $fanyi("空运") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("无最低限制") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("无最高限制") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("约10-20天") }}</div>
              </div>
            </div>
            <div class="tul tbo">
              <div class="inBox">
                <div class="tli tbo titleBox">{{ $fanyi("陆运") }}</div>
                <div class="tli tbo conBox">21kg</div>
                <div class="tli tbo conBox">{{ $fanyi("无最高限制") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("约35-45天") }}</div>
              </div>
            </div>
            <div class="tul tbo">
              <div class="inBox">
                <div class="tli tbo titleBox">{{ $fanyi("海运") }}</div>
                <div class="tli tbo conBox">1m3</div>
                <div class="tli tbo conBox">{{ $fanyi("无最高限制") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("约60-70天") }}</div>
              </div>
            </div>
            <div class="tul tbo">
              <div class="inBox">
                <div class="tli tbo titleBox">{{ $fanyi("铁路货运") }}</div>
                <div class="tli tbo conBox">21kg</div>
                <div class="tli tbo conBox">{{ $fanyi("无最高限制") }}</div>
                <div class="tli tbo conBox">{{ $fanyi("约45-55天") }}</div>
              </div>
            </div>
          </div>
          <!-- 物流方式说明 -->
          <div class="logisticsMethodDescription">
            {{
              $fanyi(
                "*运输时间具体指物流公司将货物从起点运输到目的地所需的时间。因此，「运输时间」不应与「总交货时间」相混淆。这些时间为大致估算，可能会因天气、海关规定等外部因素而有所变化。你可以",
              )
            }}<span class="aLink" @click="goLogisticaEnvio">{{
              $fanyi("点击此处")
            }}</span
            >{{ $fanyi("了解更多关于物流与运输的信息。") }}
          </div>
        </div>
      </div>
      <!-- 联系我们 -->
      <div class="lianXiWoMen">
        <div class="lianXibox">
          <h1>{{ $fanyi("你需要估算货物的运输费用吗？") }}</h1>
          <div class="lianXiboxCon">
            <img
              class="boxIcon"
              src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061517555044958.svg"
              alt=""
            />
            <h2>{{ $fanyi("请联系一位专业代理") }}</h2>
            <p>
              {{
                $fanyi(
                  "按照购买步骤操作，或者提供你想要运送的货物信息，以便我们为你提供帮助。",
                )
              }}
            </p>
            <button @click="openChat">{{ $fanyi("与代理报价") }}</button>
          </div>
        </div>
      </div>
      <!-- 物流竞争优势 -->
      <div class="logisticsYouShi">
        <img
          src="../../assets/newImg/footlist/yunshu/logistica-rakumart.jpg"
          class="logisticsYouShiLeft"
          alt=""
        />
        <div class="logisticsYouShiRight">
          <div>
            <div class="YouShiRightTitle">
              {{
                $fanyi(
                  "我们在中国的物流能力创造了竞争优势，使我们的客户因其便利性和成本节约而受益。",
                )
              }}
            </div>
            <div class="YouShiRightCon">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175742537207.svg"
                alt=""
              />
              {{ $fanyi("提供 24/7 全天候支持，覆盖交付的各个阶段") }}
            </div>
            <div class="YouShiRightCon">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175742537207.svg"
                alt=""
              />
              {{ $fanyi("享受优化的运输和进口费用") }}
            </div>
            <div class="YouShiRightCon">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175742537207.svg"
                alt=""
              />
              {{ $fanyi("包括仓储、操作和质量控制") }}
            </div>
            <div class="YouShiRightCon">
              <img
                src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175742537207.svg"
                alt=""
              />
              {{ $fanyi("从您的控制面板追踪进口") }}
            </div>
          </div>
        </div>
      </div>
      <!-- 物流中心 -->
      <div class="moudlebackGround">
        <div class="logisticsCenter pageMoudle">
          <div class="logisticsCenterOpt">
            <div class="CenterOptIcon" />
            <div class="CenterOptTt">
              {{ $fanyi("中国和意大利的物流中心") }}
            </div>
            <div class="CenterOptCon">
              {{
                $fanyi(
                  "我们拥有物流中心，确保货物运输的绝对安全。在这些中心里，我们专业的团队每天执行货物分拣、储存、操作、质量控制等任务。",
                )
              }}
            </div>
            <div class="CenterOptCon">
              {{
                $fanyi(
                  "Rakumart的这一业务领域是一个巨大优势，因为我们正在努力出色地覆盖和管理客户的供应链。",
                )
              }}
            </div>
          </div>
          <div class="logisticsCenterOpt">
            <img
              src="../../assets/newImg/footlist/yunshu/rakumart-costes-envio.jpg"
              class="CenterOptImg"
              alt=""
            />
          </div>
        </div>
      </div>

      <!-- 物流服务 -->
      <div class="moudlebackGround">
        <div class="logisticsService pageMoudle">
          <div class="Servicebiaoti">
            <span>{{ $fanyi("物流服务包括：") }}</span>
            <div class="xian"></div>
          </div>
          <div class="ServiceAll">
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG67.png"
                alt=""
              />
              <span>{{ $fanyi("从工厂接收货物") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG60.png"
                alt=""
              />
              <span>{{ $fanyi("货物存储") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG66.png"
                alt=""
              />
              <span>{{ $fanyi("货物处理") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG62.png"
                alt=""
              />
              <span>{{ $fanyi("质量控制") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG61.png"
                alt=""
              />
              <span>{{ $fanyi("生产制造证书") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG63.png"
                alt=""
              />
              <span>{{ $fanyi("海关清关") }}</span>
            </div>
            <div class="ServiceOpt">
              <img
                src="../../assets/newImg/footlist/yunshu/WechatIMG68.png"
                alt=""
              />
              <span>{{ $fanyi("其他按需服务") }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 运费明细 -->
      <div class="moudlebackGround">
        <div class="shippingDetails pageMoudle">
          <div class="shippingbiaoti">
            <span>{{ $fanyi("关于货运与运输的信息：") }}</span>
            <div class="xian"></div>
          </div>
          <div class="liebiao">
            <div class="tit" style="margin-top: -4.5px">
              {{ $fanyi("运输费用明细") }}
            </div>
            <div class="tit2" style="margin-top: -4.5px">
              {{ $fanyi("运费中的国际运输") }}
            </div>
            <div class="conp" style="margin-top: -4.5px">
              {{ $fanyi("国际运输至意大利的费用。") }}
            </div>
            <div class="tit2" style="margin-top: -8.5px">
              {{ $fanyi("意大利国内物流") }}
            </div>
            <div class="conp" style="margin-top: -4.5px">
              {{
                $fanyi(
                  "从我们在意大利的仓库分拣并国内运输至最终收货地址的费用。",
                )
              }}
            </div>
            <div class="tit2" style="margin-top: -8.5px">
              {{ $fanyi("反倾销关税") }}
            </div>
            <div class="conp" style="margin-top: -4.5px">
              {{ $fanyi("在意大利支付货物的海关关税。") }}
            </div>
            <div class="tit2" style="margin-top: -8.5px">
              {{ $fanyi("增值税(IVA)") }}
            </div>
            <div class="conp" style="margin-top: -4.5px">
              {{ $fanyi("21%税率") }}
            </div>
            <div class="endXian"></div>
            <div class="tit">
              {{ $fanyi("禁止购买和运输的危险物品") }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "危险品是指所有具有以下特性和性质的物品：可能威胁人类生命和健康；可能对环境造成不可挽回的损害；可能对物质物品造成破坏。",
                )
              }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "被划归为这类的商品包括：动物及动物制品、植物产品、动物或植物油脂、食品制品、普通金属、精密仪器、武器和弹药、艺术品。",
                )
              }}
            </div>
            <div class="endXian"></div>
            <div class="tit">
              {{ $fanyi("国际运输公司的筛选") }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "Rakumart 将选择可靠、快捷且成本效益高的国际物流渠道来发送您的货物。",
                )
              }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "经过精细的评估，我们会考量运费成本、运输准时性及服务稳定性等因素。",
                )
              }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "我们始终保持不断更新，为您在平台上提供最佳的物流合作伙伴和运输路线。",
                )
              }}
            </div>
            <div class="endXian"></div>
            <div class="tit">{{ $fanyi("海关货物清关") }}</div>
            <div class="conp">
              {{
                $fanyi(
                  "货物的海关清关将根据您在申请交付时选择的清关方式（海运、空运或陆运）进行确定。",
                )
              }}
            </div>
            <div class="conp">
              {{
                $fanyi(
                  "我们公司将负责相关的海关清关事宜。如果客户希望自行办理清关手续，也可以选择自行处理。",
                )
              }}
            </div>
            <div class="endXian"></div>
          </div>
        </div>
      </div>

      <!-- 专家代理 -->
      <div class="moudlebackGround">
        <div class="expertAgent pageMoudle">
          <img
            class="expertAgentIcon"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/2026061517555044958.svg"
            alt=""
          />
          <div class="expertAgentCon">
            <h1>{{ $fanyi("联系一位专家代理") }}</h1>
            <p>
              {{
                $fanyi(
                  "您是否正在寻找从中国进口的最佳解决方案？Rakumart就是答案，我们为您处理所有事宜，从购买产品到送达收货地址。请联系一位专业代理，开始享受我们所有的优势吧。",
                )
              }}
            </p>
            <button @click="openChat">{{ $fanyi("联系代理人") }}</button>
          </div>
        </div>
      </div>
    </div>
    <FootVue></FootVue>
  </div>
</template>
<script>
import FootVue from "../../components/foot/Foot.vue";
import HomePageTopVue from "../../components/head/HomePageTop.vue";
export default {
  // 页头：sr-only h1 供 SEO；可见文案恢复为 我们为您全权管理（caption-kicker）
  data() {
    return {};
  },
  components: { HomePageTopVue, FootVue },
  computed: {
    evn() {
      // || location.origin == 'http://localhost:8080'
      if (
        location.origin == "https://www.rakumart.it" ||
        location.origin == "https://rakumart.eu" ||
        location.origin == "www.rakumart.it" ||
        location.origin == "http://www.rakumart.it"
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  created() {},
  methods: {
    openChat() {
      this.$fun.clickJs();
    },
    // 跳转物流与运输说明页
    goLogisticaEnvio() {
      this.$fun.routerToPage("/logistica-y-envio");
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "../../css/mixin.scss";

.st0 {
  fill: #94aff6;
}

.moudlebackGround {
  min-width: 1400px;
  background-color: white;
  display: flex;
  justify-content: center;
}

.LogisticsCon {
  margin-top: -18px;

  .pageMoudle {
    width: 1200px;
    margin: 0 auto;
  }

  .logoImg {
    height: 456px;
    position: relative;
    background-image: url("https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/20260615175335156902.png");
    background-size: 100% auto;
    background-position: 50% 50%;

    .base-w {
      width: 1200px;
      height: 100%;
      margin: 0 auto;
      display: flex;

      align-items: center;
    }

    .logoInfoTxtBox {
      color: white;

      // 页头可见小标题（原 我们为您全权管理 文案）
      .caption-kicker {
        color: #ffad00;
        font-size: 12px;
        letter-spacing: 2px;
      }

      h2 {
        line-height: 13px;
        font-size: 26px;
        font-weight: 600;

        margin: 40px 0 30px;
      }

      h3 {
        font-size: 16px;
        line-height: 28px;
        font-weight: 400;
      }
    }
  }

  .lianXiWoMen {
    height: 487px;
    display: flex;
    justify-content: center;
    align-items: center;

    .lianXibox {
      h1 {
        color: #3c4043;
        font-family: "Open Sans", Sans-serif;
        font-size: 21px;
        font-weight: 500;
        line-height: 1.5em;
        text-align: center;
        height: 31px;
        margin-bottom: 10px;
      }

      .lianXiboxCon {
        width: 500px;
        background-color: #ffffff;
        border-style: solid;
        border-width: 1px 1px 1px 1px;
        border-color: #e3e3e3;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
        transition: background 0.3s, border 0.3s, border-radius 0.3s,
          box-shadow 0.3s;
        padding: 30px 20px 25px 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .boxIcon {
          width: 45.8px;
          height: 45.8px;
          margin-bottom: 6px;
        }

        h2 {
          margin-bottom: 5px;
          color: #404040;
          font-family: "Open Sans", Sans-serif;
          font-size: 18px;
          font-weight: 500;
          line-height: 1.6em;
          margin-bottom: 5px;
        }

        p {
          font-family: "Open Sans", Sans-serif;
          font-size: 16px;
          font-weight: 400;
          width: 437px;
          line-height: 1.8em;
          margin-bottom: 20px;
        }

        button {
          fill: #009246;
          color: #009246;
          background-color: #ffffff00;
          border-style: solid;
          border-width: 1px 1px 1px 1px;
          border-color: #cecece;
          border-radius: 4px 4px 4px 4px;
          padding: 12px 30px 12px 30px;
          display: inline-block;
          line-height: 1;
          font-size: 15px;
          padding: 12px 24px;
          border-radius: 8px;
          font-weight: 600;

          &:hover {
            color: #009246;
            background-color: #f1faef;
            border-color: #bddbb8;
          }
        }
      }
    }
  }

  .logisticsProcess {
    padding-bottom: 10px;
    margin-bottom: 80px;

    .AdvantagesTitle {
      display: flex;
      align-items: center;
      margin-bottom: 50px;

      span {
        display: flex;
        padding-left: 12px;
        align-items: center;
        width: 224px;
        font-size: 24px;
        font-weight: 400;
        line-height: 1.5em;
      }

      .xian {
        flex: 1;
        height: 1px;
        background-color: #b4b4b4;
        margin-top: 10px;
      }
    }

    .logisticsProcessOptImg {
      width: 1100px;
      height: 95px;
      margin: 0 auto;
      display: block;
    }

    .logisticsProcessOPtArr {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 1180px;
      margin: 0 auto;

      .logisticsProcessOPt {
        flex: 1;
        padding: 10px 0px 24.4px;
        line-height: 1.5;
        font-size: 16px;
        font-weight: 600;
        text-align: center;
      }
    }
  }

  .ourAdvantages {
    padding: 80px 0;

    .AdvantagesTitle {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      span {
        display: flex;
        padding-left: 12px;
        align-items: center;
        width: 269px;
        font-size: 24px;
        font-weight: 400;
        line-height: 1.5em;
      }

      .xian {
        flex: 1;
        height: 1px;
        background-color: #b4b4b4;
        margin-top: 10px;
      }
    }

    .AdvantagesTagGroup {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .AdvantagesTag {
        width: 400px;
        height: 153.67px;
        display: flex;
        align-items: flex-start;
        padding: 15px;

        .tagLeftIcon {
          width: 43.59px;
          height: 43.59px;
          margin-right: 15px;
        }

        .tagRightCon {
          .tagRightConTitle {
            margin-top: 8px;
            margin-bottom: 15px;
            font-size: 18px;
            font-weight: 500;
            line-height: 0.8em;
          }

          .tagRightConTBody {
            font-size: 16px;
            font-weight: 400;
            line-height: 1.8em;
          }
        }
      }
    }
  }

  .companyLabor {
    position: relative;
    display: flex;
    margin-bottom: 80px;

    .LaborBackImg {
      width: 976px;
      margin-left: auto;
      height: 100%;
    }

    .LaborFontBox {
      position: absolute;
      left: 0;
      top: 100px;
      width: 553.5px;
      height: 530px;

      .LaborLinkFont {
        color: #009246;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        line-height: 1.2em;
        letter-spacing: 2px;
        margin-bottom: 34px;
      }

      .LaborFontTitle {
        font-family: "Open Sans", Sans-serif;
        font-size: 21px;
        font-weight: 400;
        line-height: 1.5em;
        margin-bottom: 30px;
      }

      .LaborFontCon {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
        margin-bottom: 14.4px;
      }
    }
  }

  // 物流方式表格
  .modeOfTransportationTable {
    margin-bottom: 80px;

    .modeOfTransportation {
    }

    .modeOfTransportation > .tul {
      display: flex;
    }

    .modeOfTransportation > .tul.tfoot {
      min-height: 60px;
      display: flex;
      align-items: center;
      border: solid 1px #ebeef5;
      padding: 10px;

      .el-button {
        margin-right: 15px;
      }
    }

    // 表头
    .modeOfTransportation > .tul.ttt {
      background-color: #f0f3f6;
      border-radius: 6px;
      overflow: hidden;
    }

    // 内容
    .modeOfTransportation > .tul.tbo {
      &:nth-child(2n + 1) {
        background-color: #f9f9fb;

        border: 1px solid #f0f3f6;
      }
    }

    // 单个单元格
    .modeOfTransportation > .tul .tli {
      flex: 1;
      // border: #ebeef5 solid 1px;
    }

    // 单个单元格
    .modeOfTransportation .inBox {
      width: 1140px;
      display: flex;
      margin: 0 auto;
      // border: #ebeef5 solid 1px;
    }

    // 所有单个单元格表头
    .modeOfTransportation > .tul .tli.ttt {
      border: none;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 53px;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 2px;
      color: #7d7f8f;
    }

    // 所有单个单元格内容
    .modeOfTransportation > .tul .tli.tbo {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px 20px;
    }

    // 标题盒子
    .modeOfTransportation > .tul .tli.tbo.titleBox {
      font-size: 16px;
      font-weight: 600;
    }

    // 内容盒子
    .modeOfTransportation > .tul .tli.tbo.conBox {
      color: #808191;
      font-size: 16px;
      font-weight: 400;
      line-height: 12px;
      height: 66px;
    }
  }

  .logisticsMethodDescription {
    margin-top: 30px;
    padding: 0 30px;
    margin-bottom: 14px;
    line-height: 1.8;
    font-size: 15px;
    color: #808191;

    a,
    .aLink {
      color: #009246;
      cursor: pointer;
      text-decoration: none;
      &:hover {
        text-decoration: underline;
      }
    }
  }

  .logisticsYouShi {
    display: flex;
    justify-content: center;

    // margin-bottom: 50px;
    .logisticsYouShiLeft {
      width: 50%;
      height: 566px;
    }

    .logisticsYouShiRight {
      width: 50%;
      background-color: #062949;
      color: #ffffff;
      padding: 00px 0 0 70px;
      display: flex;
      align-items: center;

      .YouShiRightTitle {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.5em;
        margin-bottom: 30px;
      }

      .YouShiRightCon {
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        padding: 7.5px;
        display: flex;
        align-items: flex-start;

        img {
          width: 17px;
          height: 17px;
          margin-right: 5px;
          margin-top: 3px;
          flex-shrink: 0;
        }
      }
    }
  }

  .logisticsCenter {
    display: flex;
    padding-bottom: 80px;
    padding-top: 80px;

    .logisticsCenterOpt {
      height: 430px;
      padding: 15px;
      flex: 1;
      display: flex;
      justify-content: center;

      flex-direction: column;

      .CenterOptTt {
        font-size: 21px;
        font-weight: 400;
        line-height: 1.5em;
        margin-bottom: 30px;
      }

      .CenterOptCon {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
        margin-bottom: 15px;
      }

      .CenterOptImg {
        height: 400px;
        border-radius: 10px;
      }
    }
  }

  .logisticsService {
    padding-bottom: 80px;

    .Servicebiaoti {
      display: flex;
      align-items: center;

      span {
        display: flex;
        padding-left: 12px;
        align-items: center;
        width: 442.95px;
        font-size: 24px;
        font-weight: 400;
        line-height: 65px;
      }

      .xian {
        flex: 1;
        height: 1px;
        background-color: #b4b4b4;
        margin-top: 10px;
      }
    }

    .ServiceAll {
      display: flex;
      flex-wrap: wrap;
      align-items: center;

      .ServiceOpt {
        width: 400px;
        height: 81px;
        padding: 10px;
        display: flex;
        align-items: center;
        margin-top: 20px;
        padding-bottom: 16px;

        img {
          width: 55.67px;
          height: 55.67px;
          margin-right: 15px;
        }

        span {
          font-size: 17px;
          font-weight: 400;
          line-height: 30.59px;
          margin-bottom: 15px;
        }
      }
    }
  }

  .shippingDetails {
    .shippingbiaoti {
      display: flex;
      align-items: center;

      span {
        display: flex;
        padding-left: 12px;
        align-items: center;
        width: 442.95px;
        font-size: 24px;
        font-weight: 400;
        line-height: 65px;
      }

      .xian {
        flex: 1;
        height: 1px;
        background-color: #b4b4b4;
        margin-top: 10px;
      }
    }

    .liebiao {
      margin-top: 20px;
      margin-left: auto;
      width: 785px;
      padding: 20px;

      .tit {
        color: #009246;
        font-family: "Open Sans", Sans-serif;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;
        margin-bottom: 20px;
      }

      .tit2 {
        font-family: "Open Sans", Sans-serif;
        font-size: 15px;
        font-weight: 600;
        line-height: 1.8em;
        margin-bottom: 10px;
      }

      .conp {
        color: var(--e-global-color-1792e67);
        font-family: "Open Sans", Sans-serif;
        font-size: 15px;
        font-weight: 400;
        line-height: 1.8em;
        padding-bottom: 14.4px;
      }

      .endXian {
        background-color: #e3e3e3;
        box-sizing: content-box;
        border: solid 2px white;
        border-left: none;
        border-right: none;
        height: 1px;
        margin-top: 20px;
        margin-bottom: 20px;
      }
    }
  }

  .expertAgent {
    height: 451.08px;
    background-color: #f8f9fa;
    margin-bottom: 80px;
    transition: background 0.3s, border 0.3s, border-radius 0.3s,
      box-shadow 0.3s;
    margin-top: 50px;
    padding: 70px 150px 70px 150px;

    .expertAgentIcon {
      width: 40px;
      height: 40px;
      display: block;
      margin: 0 auto;
    }

    .expertAgentCon {
      width: 658px;
      padding: 10px;
      margin: 0 auto;

      > * {
        text-align: center;
      }

      display: flex;
      flex-wrap: wrap;
      justify-content: center;

      h1 {
        font-size: 21px;
        font-weight: 500;
        line-height: 1.5em;
        margin-bottom: 10px;
      }

      p {
        font-size: 16px;
        font-weight: 400;
        line-height: 1.8em;
        margin-bottom: 34px;
      }

      button {
        font-size: 15px;
        line-height: 15px;
        font-weight: 600;
        padding: 20px 80px 20px 80px;
        border-radius: 8px;
        border: #009246 solid 2px;
        color: #009246;
        transition: background-color 0.3s, border-color 0.3s, color 0.3s;
        cursor: pointer;

        &:hover {
          color: #009246;
          background-color: #f1faef;
          border-color: #bddbb8;
        }
      }
    }
  }
}
</style>
